import axios from "axios"

const fetchPermissions = async () => {
  try {
    // Fetch permissions based on the userRole
    const response = await axios.get(`${process.env.VUE_APP_BASE_URL}permissions/`,{ withCredentials: true });
    const permissions =   response.data.permissions;

    console.log("fetched permissions from api", response.data)

    // Set permissions in the Vuex store
    // commit('setUserPermissions', permissions);
    return permissions
  } catch (error) {
    console.error("Error fetching permissions:", error);
    return []
  }
}

const user = {
  state: {
    userPermissions: fetchPermissions(),
    userdetails: JSON.parse(sessionStorage.getItem("user")),
    userRole: null, //'visitor',
    // userPermissions: [], //['company_industry:read'],

    // use to show or hide edit mode
    isVisibleEditMode: false,

  },
  mutations: {
    // use to show or hide edit mode
    toggleVisibility(state) {
      state.isVisibleEditMode = !state.isVisibleEditMode;
    },
    toggleDivVisibility(state) {
      state.isDivVisible = !state.isDivVisible; 
      console.log("Div visibility toggled:", state.isDivVisible); // Log visibility state
    },
    setuserDetails(state, payload) {
      state.userdetails = payload;
    },
    setUserRole(state, role){
      state.userRole = role
    },
    setUserPermissions(state, permissions){
      state.userPermissions = permissions
      console.log("setUserPermissions mutation", state.userPermissions)
    },

  },
  actions: {
    // ... existing actions
    toggleDiv({ commit }) {
      console.log("Toggling div visibility..."); // Log action call
      commit('toggleDivVisibility');
    },
    async fetchPermissions({ commit }) {
      /** commented this because userRole is no longer required as it get sent automatically via token cookie */
      // if (!state.userRole) {
      //   console.log("can't fetch permissions because userRole wasn't set")
      //   return;
      // }

      try {
        // Fetch permissions based on the userRole
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}permissions/`,{ withCredentials: true });
        const permissions =   response.data.permissions || [];

        // let response = {
        //   "_id": "1",
        //   "name": "admin",
        //   "permissions": [
        //     "company_industry:access",
        //     "company_industry:get",
        //     "company_industry:post",
        //     // "company_industry:update",
        //   ]
        // }
        // let {permissions} = response
        console.log("fetched permissions from api", response)
        // Set permissions in the Vuex store
        commit('setUserPermissions', permissions);
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    },
    setUserRoleAndFetchPermissions({ commit, dispatch }, role) {
      if (role){
        commit('setUserRole', role);  // Set the user role in Vuex
      }
      dispatch('fetchPermissions'); // Fetch permissions after setting the role
    },
  }, 
  getters: {
    hasuserdetails : (state) => state.userdetails,
    getUserRole : (state) => state.userRole,
    getUserPermissions : (state) => state.userPermissions,
    isDivVisible : (state) => state.isDivVisible, // Getter for visibility state
  },
};

export default user